// extracted by mini-css-extract-plugin
export default {"guests":"Guests_guests__ZANuH","active":"Guests_active__dfI51","button":"Guests_button__BZfDU","body":"Guests_body__tUKQD","counter":"Guests_counter__im5EX"};